import { useHistory, useLocation } from 'react-router';

import { ManSitIllustration } from '../../../assets/illustrations/index';
import LoadingPage from '../../../components/templates/LoadingPage/LoadingPage';
import NoticePage from '../../../components/templates/NoticePage/NoticePage';
import useLoginStatus from '../../../helpers/hooks/useLoginStatus';
import { pagePaths } from '../config';
import { useCoreTranslation } from '../hooks/useCoreTranslation';
import { REDIRECTED_FROM } from '../types/accountValidation.types';

const AccountValidation = () => {
  const history = useHistory();
  const location = useLocation();
  const { label } = useCoreTranslation(__filename);
  const {
    user: { firstName, lastName },
  } = useLoginStatus();

  const queryParams = new URLSearchParams(location.search);
  const redirectedFrom = queryParams.get('redirectedFrom');
  const message =
    redirectedFrom === REDIRECTED_FROM.LOGIN
      ? `${label('Welcome')} ${firstName} ${lastName}! ${label('Ref: Welcome message')}`
      : `${label('Ref: Password changed message')}`;

  if (!firstName || !lastName) return <LoadingPage />;

  return (
    <NoticePage
      img={<ManSitIllustration width={340} height={340} />}
      withNavBar={false}
      title={message}
      actions={[
        {
          label: label('Continue', { textTransform: 'capitalize' }),
          action: () => history.replace(pagePaths.Home),
        },
      ]}
    />
  );
};
export default AccountValidation;
